import React, { useState, createContext, type ReactNode, useContext } from "react"
import { useTranslation } from "react-i18next"

interface MessageContextData {
  hasMessage: boolean
  message: string
  titleMessage: string
  setMessage: (title: string, message: string) => void
  disableMessage: () => void
}

const MessageContext = createContext<MessageContextData | undefined>(undefined)

interface MessageProviderProps {
  children: ReactNode
}

export const MessageProvider: React.FC<MessageProviderProps> = ({ children }) => {
  const [hasMessage, setHas] = useState(false)

  const [message, setMessages] = useState("")

  const [titleMessage, setTitle] = useState("")

  const setMessage = (title: string, message: string) => {
    setHas(true)

    setMessages(message)

    setTitle(title)
  }

  const disableMessage = () => {
    setHas(false)
  }

  return (
    <MessageContext.Provider value={{ hasMessage, titleMessage, message, setMessage, disableMessage }}>
      {children}
    </MessageContext.Provider>
  )
}

export const useMessage = (): MessageContextData => {
  const { t } = useTranslation("general")

  const context = useContext(MessageContext)

  if (!context) {
    throw new Error(t("label_title_erro"))
  }

  return context
}

export {}
